module.exports = __webpack_public_path__ + "img/advil_ibuprofen_200_mg_coated_tablets.db182e41.png";